import React, { useEffect, useCallback } from 'react'

import {
  FlexContainer,
  VendorPricingAgreementTiersDisplay,
} from '@components/common'

import {
  VendorPricingAgreement,
  VendorPricingAgreementScopes,
  VendorPricingAgreementServiceTypes,
  VendorPricingAgreementDiscountTypes,
} from '@types'

interface ChefVendorPricingAgreementsProps {
  chefId: string
  currentHq: number
  vendorPricingAgreements: VendorPricingAgreement[] | null
  getChefVendorPricingAgreements: (params: {
    vendorId: string
    hqId: number
  }) => Promise<VendorPricingAgreement[] | null>
  editVendorPricingAgreement: (
    vendorPricingAgreement: VendorPricingAgreement,
  ) => void
}

const ChefVendorPricingAgreements: React.FC<
  ChefVendorPricingAgreementsProps
> = ({
  chefId,
  currentHq,
  vendorPricingAgreements,
  getChefVendorPricingAgreements,
  editVendorPricingAgreement,
}) => {
  const refreshAgreement = useCallback(async () => {
    await getChefVendorPricingAgreements({ vendorId: chefId, hqId: currentHq })
  }, [getChefVendorPricingAgreements, chefId, currentHq])

  useEffect(() => {
    refreshAgreement()
  }, [refreshAgreement])

  const onAddChefVendorPricingAgreement = () => {
    editVendorPricingAgreement({
      id: '',
      scope: VendorPricingAgreementScopes.VENDOR_MARKET,
      serviceTypes: [
        VendorPricingAgreementServiceTypes.CATERING,
        VendorPricingAgreementServiceTypes.GROUP_ORDER,
      ],
      vendorId: chefId,
      hqId: currentHq,
      discountType: VendorPricingAgreementDiscountTypes.PERCENTAGE,
      tiers: [
        {
          position: 1,
          lowerLimit: 0,
          upperLimit: null,
          discountPercentage: 1,
        },
      ],
      active: true,
    })
  }

  if (!vendorPricingAgreements) {
    return (
      <FlexContainer
        width="100%"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <p className="mb-5 text-md mt-10">
          No chef vendor pricing agreement exists.
        </p>
        <button
          className="px-3 py-3 bg-blue-500 text-white rounded-md"
          onClick={onAddChefVendorPricingAgreement}
        >
          Create Vendor Pricing Agreement
        </button>
      </FlexContainer>
    )
  }

  return (
    <div className="w-full flex flex-col items-center justify-center">
      <VendorPricingAgreementTiersDisplay
        pricingAgreements={vendorPricingAgreements}
        title="Vendor Pricing Agreements"
        onCreateVendorPricingAgreement={onAddChefVendorPricingAgreement}
        editVendorPricingAgreement={editVendorPricingAgreement}
        width="66%"
      />
    </div>
  )
}

export default ChefVendorPricingAgreements
